import StudentCourseCard from "@/components/StudentCourseCard";
import type { Course } from "@/types";

const GRID_CARD_CLASSES =
  "flex w-full flex-col overflow-hidden rounded-2xl border border-ink/20 bg-white shadow-sm";

type CourseGridProps = {
  courses: Course[];
  emptyMessage: string;
};

/** Responsive grid of enrollable course cards — every matching course shown
 *  at once, no carousel/pagination cutting activities off. */
export default function CourseGrid({ courses, emptyMessage }: CourseGridProps) {
  if (courses.length === 0) {
    return (
      <p className="font-sans text-sm font-light text-ink/60">{emptyMessage}</p>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {courses.map((course) => (
        <StudentCourseCard
          key={course.id}
          course={course}
          variant="enroll"
          className={GRID_CARD_CLASSES}
        />
      ))}
    </div>
  );
}
